//#region Imports
import {
  EventEmitter,
  Output,
  Component,
  Input,
  OnDestroy,
  SimpleChanges,
} from '@angular/core';
import { AdminMenu } from '../../model/common/admin-menu-model';
import { LoggedUser } from '../../model/users/logged-user.modal';

import MainMenu from '../../../../assets/data/main-menu.json';
import { Constant } from '../../common/constant';
import { AppDataService } from 'app/modules/authentication/services/appdata.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
//#endregion Imports

@Component({
  selector: 'app-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.scss'],
})
export class SideBarComponent implements OnDestroy {
  @Output() sideBarEvent = new EventEmitter<boolean>();
  @Output() userSettingEvent = new EventEmitter<boolean>();
  @Output() changeAppEvent = new EventEmitter<boolean>();
  @Input() loggedUser: LoggedUser;
  @Input() mainSideBarStatus: boolean = false;
  @Input() hide_menu: boolean = false;
  @Input() app_menu: string;
  initals: string = '';
  sideMenuItem: AdminMenu[] = [];
  sideBarStatus: boolean;
  currentRole: string;
  currentMode: string = '';
  disableLink: boolean = false;
  last_route: string = '';
  currentUrl: string = '';

  currentApp: string = '';
  is_tablet=false;
  private routerSub: Subscription;
  private permissionSub: Subscription;
  private roleSub: Subscription;
  //#region Constructor
  constructor(
    private appData: AppDataService,
    private router: Router,
    private route: ActivatedRoute
  ) {}
  //#endregion Constructor

  //#region Init

  ngOnInit() {
    this.currentRole = this.appData.currentUserRole;
    this.loggedUser = this.appData.connectedUser;
    this.currentApp = this.appData.currentApp;

    this.disableLink = false;
    this.setSideMenu();
    this.sideBarStatus = JSON.parse(localStorage.getItem('sideBarStatus'));
    this.sideBarEvent.emit(this.sideBarStatus);
    this.roleSub = this.appData.role$.subscribe((x) => {
      this.currentRole = x.role_name;
      this.setSideMenu();
    });
    this.permissionSub = this.appData.userPermission$.subscribe(() => {
      this.setSideMenu();
    });
    let ismobile = this.isMobileView();
    if (ismobile) {
      this.sideBarStatus = false;
    }

    if (this.hide_menu) {
      this.sideBarEvent.emit(true);
    }

    this.updateActiveRoute(this.router.url.split('?')[0]);
    this.routerSub = this.router.events.pipe(
      filter(e => e instanceof NavigationEnd)
    ).subscribe((e: NavigationEnd) => {
      this.updateActiveRoute(e.urlAfterRedirects.split('?')[0]);
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    this.initals =
      this.loggedUser?.name
        ?.trim()
        ?.split(' ')
        ?.filter((word) => word.length > 0)
        ?.map((word) => word[0].toUpperCase())
        ?.slice(0, 2)
        ?.join('') || '';

    if (this.mainSideBarStatus) {
      this.sideBarStatus = false;
      Promise.resolve().then(() => this.toggleSideBar());
    } else {
      this.sideBarStatus = true;
      Promise.resolve().then(() => this.toggleSideBar());
    }
    if (changes['app_menu']?.currentValue != this.currentApp) {
      this.currentApp = this.app_menu;
      this.setSideMenu();
    }
  }

  ngOnDestroy() {
    this.routerSub?.unsubscribe();
    this.permissionSub?.unsubscribe();
    this.roleSub?.unsubscribe();
  }



  //#endregion

  //#region Helper/Action

  private updateActiveRoute(url: string): void {
    this.currentUrl = url;
    if (url.includes('/expense/expense-form/0')) {
      this.last_route = '/expense/expense-list';
    } else if (url.includes('/transcation/money-request/')) {
      this.last_route = '/transcation/wallet';
    } else if (url.includes('expense/report/')) {
      this.last_route = '/expense/report';
    } else if (!url.includes('expense/report-dashboard')) {
      // For all other URLs (direct menu routes), update last_route.
      // For report-dashboard, last_route is intentionally kept from the previous navigation
      // so that the Reports menu item stays highlighted.
      this.last_route = url;
    }
  }

  setSideMenu() {
    if (!this.hide_menu) {
      if (
        (this.currentRole?.toLocaleLowerCase() ==
          Constant.RoleName.Admin.toLocaleLowerCase() ||
          this.currentRole?.toLocaleLowerCase() ==
            Constant.RoleName.Finance.toLocaleLowerCase() ||
          this.currentRole?.toLocaleLowerCase() ==
            Constant.RoleName.Manager.toLocaleLowerCase() ||
          this.currentRole?.toLocaleLowerCase() ==
            Constant.RoleName.User.toLocaleLowerCase()) &&
        this.loggedUser.primary_account &&
        !this.loggedUser.status
      ) {
        this.sideMenuItem = this.getOnBoardMenu();
        this.currentMode = 'Onboarding';
      } else {
        if (
          this.currentRole?.toLocaleLowerCase() ==
          Constant.RoleName.Admin.toLocaleLowerCase()
        ) {
          this.sideMenuItem = this.getAdminMenu();
          this.currentMode = 'Admin';
        } else if (
          this.currentRole?.toLocaleLowerCase() ==
          Constant.RoleName.Finance.toLocaleLowerCase()
        ) {
          this.sideMenuItem = this.getFinanceMenu();
          this.currentMode = 'Finance';
        } else if (
          this.currentRole?.toLocaleLowerCase() ==
          Constant.RoleName.Manager.toLocaleLowerCase()
        ) {
          this.sideMenuItem = this.getManagerMenu();
          this.currentMode = 'Manager';
        } else if (
          this.currentRole?.toLocaleLowerCase() ==
          Constant.RoleName.User.toLocaleLowerCase()
        ) {
          this.sideMenuItem = this.getUserMenu();
          this.currentMode = 'Employee';
        }
      }
      // Trip module temporarily hidden from menu (commented out for now)
      // this.sideMenuItem = this.sideMenuItem.filter(
      //   (item) => item.name !== 'My Trips' && item.name !== 'Trips (Travel Desk)'
      // );
      // Hide this menu item for all users if they don't have permission to access trip desk
      if (!this.appData.userPermission?.user_permissions?.allow_trip_desk) {
        this.sideMenuItem = this.sideMenuItem.filter((item) => item.name !== 'Trips (Travel Desk)');
      }

      if (this.appData.connectedUser.kyc_status != 'C') {
        // Condition added as per BIZ-2008
        const isAdminOrFinance = [
          Constant.RoleName.Admin.toLocaleLowerCase(),
          Constant.RoleName.Finance.toLocaleLowerCase(),
        ].includes(this.currentRole?.toLocaleLowerCase());
        if (!isAdminOrFinance) {
          let index = this.sideMenuItem.findIndex(
            (item) => item.name == 'Money Requests'
          );
          if (index != -1) {
            this.sideMenuItem[index].active = false;
          }
        }
      }
    }
  }

  toggleSideBar(data = null) {
    if (data != null) {
      this.sideBarStatus = !this.sideBarStatus;
    }
    if (this.sideBarStatus) {
      this.sideBarEvent.emit(this.sideBarStatus);
      localStorage.setItem('sideBarStatus', this.sideBarStatus.toString());
    } else {
      this.sideBarStatus = false;
      this.sideBarEvent.emit(false);
      localStorage.setItem('sideBarStatus', false.toString());
    }
  }

  openUserSetting() {
    this.userSettingEvent.emit(true);
  }
  //#endregion

  //#region
  getOnBoardMenu(): AdminMenu[] {
    return JSON.parse(JSON.stringify(MainMenu.onboard));
  }

  getAdminMenu(): AdminMenu[] {
    if (this.currentApp == 'EMS') {
      return JSON.parse(JSON.stringify(MainMenu.admin));
    } else {
      return JSON.parse(JSON.stringify(MainMenu.vms_admin));
    }
  }

  getFinanceMenu(): AdminMenu[] {
    return JSON.parse(JSON.stringify(MainMenu.finance));
  }

  getManagerMenu(): AdminMenu[] {
    return JSON.parse(JSON.stringify(MainMenu.manager));
  }

  getUserMenu(): AdminMenu[] {
    return JSON.parse(JSON.stringify(MainMenu.user));
  }

  isMobileView(): boolean {
    const mobileQuery = window.matchMedia('(max-width: 480px)'); // Adjust the width as needed
    return mobileQuery.matches;
  }

  checkParentRoute(targetUrl: string): boolean {
    const currentUrl = this.currentUrl;

    // Rule 1: expense-list is active when on the new expense form
    if (targetUrl === '/expense/expense-list' && currentUrl.includes('/expense/expense-form/0')) {
      return true;
    }

  // Rule 2: '/transcation/wallet' should be active if we're on the money request page
  if (targetUrl === '/transcation/wallet' && currentUrl.includes('/transcation/money-request/')) {
    this.last_route = targetUrl;
    return true;
  }

    // Rule 3: report is active when inside a specific report
    if (targetUrl === '/expense/report' && currentUrl.includes('expense/report/')) {
      return true;
    }

    // Exact URL match
    if (targetUrl === currentUrl) {
      return true;
    }

    // Sticky match: keeps the parent menu item active for sub-pages like report-dashboard
    if (targetUrl === this.last_route) {
      return true;
    }

    return false;
  }

//#endregion

isTablet(): boolean {
  const width = window.innerWidth;
  return  width <= 1024;
}

  checkTabAndClose(){
    if (this.isTablet()){
      this.toggleSideBar(true);
    }
  }

  getAppName() {
    let bizpay_app = [
      { id: 'EMS', name: 'Expense Management System', icon: 'pi pi-file' },
      { id: 'VMS', name: 'Vendor Management System', icon: 'pi pi-cart' },
    ];
    return bizpay_app.find((x) => x.id == this.currentApp)?.name;
  }

  changeApp() {
    this.changeAppEvent.emit(true);
  }

  trackByMenuRoute(_index: number, item: any): string {
    return item.routerLink ?? item.name;
  }
}
